<template>
    <a :href="href" class="hexagon" :data-label="label"
       :style="{ '--hex-color': backgroundcolor,  '--text-color': textcolor, '--highlight-text': highlighttextcolor }">
      <div class="side"></div>
      <div class="side"></div>
    </a>
  </template>
  
  <script>
  export default {
    name: 'HexagonButton',
    props: {
      href: {
        type: String,
        default: '#',
      },
      label: {
        type: String,
        default: 'NEW',
      },
      backgroundcolor: {
        type: String,
        default: "#151515",
      },
      textcolor: {
        type: String,
        default: "white",
      },
      highlighttextcolor: {
        type: String,
        default: "white",
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .hexagon {
    position: relative;
    width: 10.5em;
    height: 6em;
    background: var(--hex-color);
    box-shadow: -6px -6px 9px rgba(255, 255, 255, 0.5),
      6px 6px 9px rgba(70, 70, 70, 0.12);
  }
  
  .hexagon .side {
    position: absolute;
    width: 100%;
    height: 100%;
    background: inherit;
    box-shadow: -6px -6px 9px rgba(255, 255, 255, 0.5),
      6px 6px 9px rgba(70, 70, 70, 0.12);
  }
  
  .hexagon .side:nth-child(1) {
    transform: rotate(60deg);
  }
  
  .hexagon .side:nth-child(2) {
    transform: rotate(-60deg);
  }
  
  .hexagon::before {
    box-sizing: border-box;
    padding-top: 1.2em;
    text-align: center;
    content: attr(data-label);
    color: var(--text-color);
    position: absolute;
    width: 100%;
    height: 100%;
    background: inherit;
    z-index: 3;
    font-size: 1.8em;
    transition: 0.4s;
    text-decoration: none;
    font-family: sans-serif;
    text-shadow: 0 0 1px var(--highlight-text), 0 0 1px var(--highlight-text), 0 0 1px var(--highlight-text), 0 0 1px var(--highlight-text);
  }
  
  .hexagon::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: inherit;
    z-index: 2;
    transform: rotate(60deg);
  }
  
  .hexagon:hover::before{
    color: var(--highlight-text);
    text-shadow: 0 0 5px var(--highlight-text), 0 0 10px var(--highlight-text), 0 0 15px var(--highlight-text), 0 0 20px var(--highlight-text);
  }

  .hexagon .side, .hexagon {
    box-shadow: -3px -3px 5px rgba(255,255,255,0.05), 3px 3px 5px rgba(0,0, 0,0.6);
  }

  
  </style>
  